import styled from 'styled-components';

export const AlertContainer = styled.div`
  margin-top: 12px;
`;
